<template>
  <div>
    <OfflineIndicator />
    <router-view />
    <PwaInstallPrompt />
    <PwaUpdatePrompt />
  </div>
</template>

<script>
import PwaUpdatePrompt from './components/PwaUpdatePrompt.vue'
import PwaInstallPrompt from './components/PwaInstallPrompt.vue'
import OfflineIndicator from './components/OfflineIndicator.vue'

export default {
  name: 'App',
  components: {
    PwaUpdatePrompt,
    PwaInstallPrompt,
    OfflineIndicator
  }
}
</script>

<style>
</style>
